import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

class StepResultFields extends React.Component {
  state = {
    stepResultFields: this.props.stepResultFields,
    selectedProgramDirector: {
      id: this.props.programDirectors[0].id,
      label: this.props.programDirectors[0].full_name_reverse
    },
    selectedInstructorTrainer: {
      id: this.props.instructorTrainers[0].id,
      label: this.props.instructorTrainers[0].full_name_reverse
    },
    selectedTrainingCenter: {
      id: this.props.trainingCenters[0].id,
      label: this.props.trainingCenters[0].name
    }
  };

  componentDidUpdate(prevProps) {
    if(prevProps.stepResultFields !== this.props.stepResultFields) {
      this.setState({
        stepResultFields: this.props.stepResultFields,
        selectedProgramDirector: {
          id: this.props.programDirectors[0].id,
          label: this.props.programDirectors[0].full_name_reverse
        },
        selectedInstructorTrainer: {
          id: this.props.instructorTrainers[0].id,
          label: this.props.instructorTrainers[0].full_name_reverse
        },
        selectedTrainingCenter: {
          id: this.props.trainingCenters[0].id,
          label: this.props.trainingCenters[0].name
        }
      });
    }
  }

  render() {
    const {
      stepResultFields,
      selectedProgramDirector,
      selectedInstructorTrainer,
      selectedTrainingCenter
    } = this.state;

    const {
      onChange,
      programDirectors,
      instructorTrainers,
      trainingCenters
    } = this.props;

    return (
      <div className='col-xs-12 col-md-12'>
        <hr />
        <h4>{stepResultFields.name}</h4>
        <label htmlFor="completed-date-input">
          Completed Date
        </label>
        <br />
        <input
          id="completed-date-input"
          className='form-control completed-date-picker'
          type='date'
          onChange={e => this.handleInputChange(e.target.value, 'completed_on')}
          value={stepResultFields.completed_on}
        />
        <label id="program-director-label">
          Program Director
        </label>
        <br />
        <Select
          aria-labelledby="program-director-label"
          closeMenuOnSelect={true}
          onChange={e => this.handleInputChange(e, 'program_director_id')}
          options={programDirectors.map(programDirector => ({
            label: this.props.isSaiAdmin ? programDirector.full_name_reverse_with_account : programDirector.full_name_reverse,
            value: programDirector.id
          }))}
          placeholder={"Select a Program Director *"}
          removeSelected={true}
          simpleValue
          value={selectedProgramDirector}
        />
        <label id="instructor-trainer-label">
          Instructor Trainer
        </label>
        <br />
        <Select
          aria-labelledby="instructor-trainer-label"
          closeMenuOnSelect={true}
          onChange={e => this.handleInputChange(e, 'instructor_trainer_id')}
          options={instructorTrainers.map(instructorTrainer => ({
            label: this.props.isSaiAdmin ? instructorTrainer.full_name_reverse_with_account : instructorTrainer.full_name_reverse,
            value: instructorTrainer.id
          }))}
          placeholder={"Select a Instructor Trainer *"}
          removeSelected={true}
          simpleValue
          value={selectedInstructorTrainer}
        />
        <label id="training-center-label">
          Training Center
        </label>
        <br />
        <Select
          aria-labelledby="training-center-label"
          closeMenuOnSelect={true}
          onChange={e => this.handleInputChange(e, 'training_center_id')}
          options={trainingCenters.map(trainingCenter => ({
            label: trainingCenter.name,
            value: trainingCenter.id
          }))}
          placeholder={"Select a Training Center *"}
          removeSelected={true}
          simpleValue
          value={selectedTrainingCenter}
        />
      </div>
    );
  }

  handleInputChange = (newValue, key) => {
    let stepResultFields = this.state.stepResultFields;
    let selectedProgramDirector = this.state.selectedProgramDirector;
    let selectedInstructorTrainer = this.state.selectedInstructorTrainer;
    let selectedTrainingCenter = this.state.selectedTrainingCenter;
    !(key in stepResultFields) && (stepResultFields[key] = {});

    switch(key) {
      case "program_director_id":
        stepResultFields[key] = newValue.value;
        selectedProgramDirector = newValue;
        break;
      case "instructor_trainer_id":
        stepResultFields[key] = newValue.value;
        selectedInstructorTrainer = newValue;
        break;
      case "training_center_id":
        stepResultFields[key] = newValue.value;
        selectedTrainingCenter = newValue;
        break;
      default:
        stepResultFields[key] = newValue;
    }

    this.setState({
      stepResultFields: stepResultFields,
      selectedProgramDirector: selectedProgramDirector,
      selectedInstructorTrainer: selectedInstructorTrainer,
      selectedTrainingCenter: selectedTrainingCenter
    });
    this.props.onChange(stepResultFields, "stepResultFields", this.props.index);
  };

}

StepResultFields.propTypes = {
  index: PropTypes.number,
  stepResultFields: PropTypes.object,
  onChange: PropTypes.func,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  isSaiAdmin: PropTypes.bool
};


export default StepResultFields;
